export default __webpack_public_path__ + "static/media/safari-pinned-tab.5315941d.png";